import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.peopleManagement'),
    id: 'peopleManagement',
    sidebar: [
        {
            id: 'roles',
            label: i18n.tc('configuration.sections.roles', 2),
            icon: 'fal fa-pencil-ruler',
            routeName: 'PeopleRoles',
            hasChildren: false
        },
        {
            id: 'jobs',
            label: i18n.tc('configuration.sections.jobs', 2),
            icon: 'fal fa-sitemap',
            routeName: 'PeopleJobs',
            hasChildren: false
        },
        {
            id: 'petitioners',
            label: i18n.tc('configuration.sections.petitioners', 2),
            icon: 'fal fa-user-md',
            routeName: 'PeoplePetitioners',
            hasChildren: false
        },
        {
            id: 'personnel',
            label: i18n.tc('configuration.sections.personnel', 2),
            icon: 'fal fa-hospital-user',
            routeName: 'PeoplePersonnel',
            hasChildren: false
        },
        {
            id: 'userapp',
            label: i18n.tc('configuration.sections.users', 2),
            icon: 'fal fa-users',
            routeName: 'PeopleUserapp',
            hasChildren: false
        }
    ]
}
